import React from "react";

const NewsPreviewTitle = props => {
  const { postTitle } = props;
  return (
    <React.Fragment>
      <h1 className="events-page-post-title">{postTitle}</h1>
    </React.Fragment>
  );
};

export default NewsPreviewTitle;
